import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export type TabItem<K extends string> = { key: K; label: ReactNode; count?: number; hidden?: boolean };

export function Tabs<K extends string>({ tabs, active, onChange }: { tabs: TabItem<K>[]; active: K; onChange: (k: K) => void }) {
  return (
    <div className="mb-4 overflow-x-auto border-b border-slate-200" role="tablist">
      <div className="flex gap-1">
        {tabs
          .filter((t) => !t.hidden)
          .map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={active === t.key}
              onClick={() => onChange(t.key)}
              className={cn(
                '-mb-px flex items-center gap-1.5 border-b-2 px-3 py-2 text-sm font-medium whitespace-nowrap',
                active === t.key ? 'border-brand-600 text-brand-700' : 'border-transparent text-slate-500 hover:text-slate-800',
              )}
            >
              {t.label}
              {t.count !== undefined && t.count > 0 && <span className="rounded-full bg-slate-100 px-1.5 text-xs text-slate-600">{t.count}</span>}
            </button>
          ))}
      </div>
    </div>
  );
}
